export const pluralizeString = (word, count) => (count > 1 ? word + 's' : word)
